import type { ReactNode } from 'react';

export const symbol_sheets_rtl: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M249-101 145-205q-9-9-9-21t9-21l104-104q9-9 21-9t20.87 8.84q9.13 8.84 8.63 21T291-309l-52 53h531q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H239l52 53q8.25 8.8 8.63 20.9Q300-110 291-101q-9 9-21 9t-21-9Zm-44-339q-18.75 0-31.87-13.13Q160-466.25 160-485v-390q0-18.75 13.13-31.88Q186.25-920 205-920h550q18.75 0 31.88 13.12Q800-893.75 800-875v390q0 18.75-13.12 31.87Q773.75-440 755-440H205Zm15-270h230v-150H220v150Zm290 0h230v-150H510v150Zm-60 210v-150H220v150h230Zm60 0h230v-150H510v150Z"
		/>
	</svg>
);
